import React, { useContext, useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProductContext } from '../../context/ProductContext.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "./ProductDetail.css";
import { getApiUrl } from '../../config';

// CardContext yerine RTK Query hook'unu içe aktarıyoruz
import { useAddToCartMutation, useClearCartMutation, useGetCartQuery } from '../../services/cartApi';

import { FavoriteContext } from '../../context/FavoriteContext.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as SolidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as RegularHeart } from '@fortawesome/free-regular-svg-icons';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import Popup from '../../components/PopUp.js';
import AddToCartModal from '../../components/product/AddToCartModal.js';
import ImageGallery from './ImageGallery.js';
import { useImage } from "../../context/ImageContext.js";
import { Helmet } from "react-helmet-async";
import Loader from '../../components/Loader.js';
import ProductCard from '../../components/product/ProductCard.js';

import SoldAlert from '../../components/SoldAlert';
import { InstitutionalContext } from '../../context/InstitutionalContext.js';


const ProductDetails = () => {
  const { sef } = useParams();
  const { getImageUrl } = useImage();

  // RTK Query hook'unu kullanarak addToCart fonksiyonunu alıyoruz
  const [addToCart] = useAddToCartMutation();
  const [clearCart] = useClearCartMutation();
  const { data: cartData } = useGetCartQuery();

  const { state, fetchProductById, fetchStoreProduct, fetchProducts } = useContext(ProductContext);
  const { products, loading, error, productDetails, store } = state;
  const { favorites, addToFavorite, removeFavorite } = useContext(FavoriteContext);
  const [activeTab, setActiveTab] = useState('description');
  const [message, setMessage] = useState('');
  const [productLimit, setProductLimit] = useState(5);

  // Ekran boyutuna göre productLimit'i ayarla
  useEffect(() => {
    const handleResize = () => {
      setProductLimit(window.innerWidth < 768 ? 4 : 5);
    };

    // İlk yüklemede çalıştır
    handleResize();

    // Ekran boyutu değiştiğinde güncelle
    window.addEventListener('resize', handleResize);

    // Temizleme fonksiyonu
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const [showPopup, setShowPopup] = useState(false);
  const [showSarrafiyeModal, setShowSarrafiyeModal] = useState(false);
  const [isBuyNowAction, setIsBuyNowAction] = useState(false);
  const [selectedSize, setSelectedSize] = useState(15);
  const [isRingLocked, setIsRingLocked] = useState(false);
  const { institutionals, fetchInstitutional } = useContext(InstitutionalContext);
  const [shareMessage, setShareMessage] = useState('');
  const [ringPricing, setRingPricing] = useState(null);
  const [loadingRingPrice, setLoadingRingPrice] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [showAddToCartModal, setShowAddToCartModal] = useState(false);

  useEffect(() => {
    const shippingCategory = "teslimat-ve-iade";
    if (!institutionals?.sef || institutionals.sef !== shippingCategory) {
      fetchInstitutional(shippingCategory);
    }
  }, [institutionals?.sef]);

  // Yüzük ölçüsü kilit durumunu kontrol et
  useEffect(() => {
    if (productDetails) {
      if (productDetails.ring_size_lock === 1) {
        setIsRingLocked(true);
        setSelectedSize(Number(productDetails.ring_size) || 15);
      } else {
        setIsRingLocked(false);
        setSelectedSize(Number(productDetails.ring_size) || 15);
      }
    }
  }, [productDetails]);

  const shuffleArray = (array) => {
    let shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  };

  const isSarrafiyeProduct = useMemo(() => {
    if (!productDetails || !productDetails.id) return false;
    return productDetails.sarrafiye == 1;
  }, [productDetails]);

  const hasNonSarrafiyeInCart = useMemo(() => {
    if (!cartData || !Array.isArray(cartData)) return false;

    return cartData.some(item => item.sarrafiye != 1);
  }, [cartData]);

  const hasSarrafiyeInCart = useMemo(() => {
    if (!cartData || !Array.isArray(cartData)) return false;

    return cartData.some(item => item.sarrafiye == 1);
  }, [cartData]);

  const handleAddToCart = async () => {
    // Çoklu tıklama koruması
    if (isAddingToCart) {
      return;
    }

    if ((productDetails.kategori.includes("75") || productDetails.kategori.includes("103") || productDetails.kategori.includes("112")) && !selectedSize) {
      setMessage("Lütfen ölçü seçin");
      setShowPopup(true);
      return;
    }

    if ((isSarrafiyeProduct && hasNonSarrafiyeInCart) || (!isSarrafiyeProduct && hasSarrafiyeInCart)) {
      setShowSarrafiyeModal(true);
      return;
    }

    await addProductToCart();
  };

  const addProductToCart = async () => {
    setIsAddingToCart(true);
    try {
      if (productDetails.kategori.includes("75") || productDetails.kategori.includes("103") || productDetails.kategori.includes("112")) {
        await addToCart({ urun_id: productDetails.id, size: selectedSize });
      } else {
        await addToCart({ urun_id: productDetails.id });
      }

      setShowAddToCartModal(true);
    } catch (error) {
      console.error("Sepete eklenirken hata oluştu:", error);
      setMessage("Ürün sepete eklenirken bir hata oluştu");
      setShowPopup(true);
    } finally {
      setIsAddingToCart(false);
    }
  };

  const handleSarrafiyeConfirm = async (goToCart = false) => {
    setIsAddingToCart(true);
    try {
      // Önce sepeti temizle
      await clearCart();

      // Sonra ürünü ekle
      if (productDetails.kategori.includes("75") || productDetails.kategori.includes("103") || productDetails.kategori.includes("112")) {
        await addToCart({ urun_id: productDetails.id, size: selectedSize });
      } else {
        await addToCart({ urun_id: productDetails.id });
      }

      setShowSarrafiyeModal(false);
      setIsBuyNowAction(false);

      if (goToCart) {
        setTimeout(() => {
          window.location.href = "/card";
        }, 300);
      } else {
        setShowAddToCartModal(true);
      }
    } catch (error) {
      console.error("Sepet temizleme veya ürün ekleme hatası:", error);
      setMessage("İşlem sırasında bir hata oluştu");
      setShowPopup(true);
      setShowSarrafiyeModal(false);
      setIsBuyNowAction(false);
    } finally {
      setIsAddingToCart(false);
    }
  };

  const handleSarrafiyeCancel = () => {
    setShowSarrafiyeModal(false);
    setIsBuyNowAction(false);
  };

  const handleSizeChange = async (event) => {
    if (isRingLocked) {
      return; // kilitliyse değişime izin verme
    }

    const newSize = Number(event.target.value);
    setSelectedSize(newSize);

    // Backend'den fiyat farkını al
    await fetchRingSizePrice(newSize);
  };

  const fetchRingSizePrice = async (size) => {
    if (!productDetails?.id || isRingLocked) {
      setRingPricing(null);
      return;
    }

    setLoadingRingPrice(true);
    try {
      const response = await fetch(`${getApiUrl()}/ring-size-price`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          product_id: productDetails.id,
          selected_size: size
        })
      });

      if (response.ok) {
        const data = await response.json();
        setRingPricing(data);
      } else {
        console.error('Ring size price fetch failed');
        setRingPricing(null);
      }
    } catch (error) {
      console.error('Error fetching ring size price:', error);
      setRingPricing(null);
    } finally {
      setLoadingRingPrice(false);
    }
  };

  const getRingSizeDescription = () => {
    if (isRingLocked) {
      return '';
    }

    if (loadingRingPrice) {
      return 'Fiyat hesaplanıyor...';
    }

    if (ringPricing) {
      if (ringPricing.price_difference === 0) {
        return '';
      }
      return `Ek Ücret: ${ringPricing.description}`;
    }

    return '';
  };

  const handleContinueShopping = () => {
    setShowPopup(false);
  };

  const handleGoToCart = () => {
    window.location.href = "/card";
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (!products || products.id !== parseInt(sef)) {
      fetchProducts(sef);
    }
  }, []);

  useEffect(() => {
    if (!productDetails || productDetails.id !== parseInt(sef)) {
      fetchProductById(sef);
    }
  }, [sef]);

  useEffect(() => {
    // Ürün detay geldikten sonra varsayılan yüzük ölçüsü ve kilit durumunu set et
    if (
      productDetails &&
      (productDetails.kategori?.includes("75") ||
        productDetails.kategori?.includes("103") ||
        productDetails.kategori?.includes("112"))
    ) {
      // Eski sistem kontrolü - eğer ring_size null ise varsayılan ölçü 15 kullan
      let defaultRingSize;
      if (productDetails.ring_size) {
        defaultRingSize = Number(productDetails.ring_size);
      } else {
        defaultRingSize = 15; // Varsayılan ölçü
      }

      const ringLock = Number(productDetails?.ring_size_lock ?? 0) === 1;
      setSelectedSize(defaultRingSize);
      setIsRingLocked(ringLock);

      // Varsayılan ölçü için fiyat hesaplaması yap
      fetchRingSizePrice(defaultRingSize);
    }
  }, [productDetails]);

  useEffect(() => {
    if (!store || store.sef !== parseInt(sef)) {
      fetchStoreProduct(sef);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isFavorite = (product) => {
    return favorites && favorites.length > 0 && favorites.some(favProduct =>
      String(favProduct.urun_id) === String(product.id)
    );
  };

  const handleFavoriteToggle = async () => {
    try {
      if (isFavorite(productDetails)) {
        // Favori ID'sini bul
        const favoriteProduct = favorites.find(fav =>
          String(fav.urun_id) === String(productDetails.id)
        );
        if (favoriteProduct) {
          await removeFavorite(favoriteProduct);
        }
      } else {
        await addToFavorite(productDetails);
      }
    } catch (error) {
      console.error('Favori işlemi sırasında hata:', error);
    }
  };

  // Önerilen ürünler için ayrı bir favori işleme fonksiyonu
  const handleRecommendedFavoriteToggle = async (e, product) => {
    e.stopPropagation();
    e.preventDefault();

    try {
      if (isFavorite(product)) {
        const favoriteProduct = favorites.find(fav =>
          String(fav.urun_id) === String(product.id)
        );
        if (favoriteProduct) {
          await removeFavorite(favoriteProduct);
        }
      } else {
        await addToFavorite(product);
      }
    } catch (error) {
      console.error('Favori işlemi sırasında hata:', error);
    }
  };

  const isOutOfStock = productDetails?.stok === 0;

  const handleShare = async () => {
    const shareUrl = window.location.href;
    const shareTitle = productDetails.baslik;

    try {
      if (navigator.share) {
        await navigator.share({
          title: shareTitle,
          url: shareUrl
        });
      } else {
        await navigator.clipboard.writeText(shareUrl);
        setMessage("Ürün bağlantısı panoya kopyalandı");
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Paylaşım sırasında hata:', error);
    }
  };

  if (!productDetails && loading) return <Loader />;
  if (error) return <div>Hata: {error}</div>;
  if (!loading && !productDetails) {
    return <div></div>;
  }

  return (
    <>
      <div>
        <Helmet>
          <title>BiKuyum | {productDetails ? productDetails.baslik : 'Mağaza'}</title>

          {/* Meta Description */}
          <meta
            name="description"
            content={`${productDetails ? productDetails.baslik : ''} - ${productDetails ? productDetails.ayar : ''} ayar ${productDetails ? productDetails.gram : ''} gram altın ürünü. ${productDetails ? productDetails.fiyat.toLocaleString('tr-TR') : ''} TL fiyatıyla BiKuyum'da. Güvenli alışveriş, hızlı teslimat.`}
          />

          {/* Meta Keywords */}
          <meta
            name="keywords"
            content={`${productDetails ? productDetails.baslik : ''}, ${productDetails ? productDetails.ayar : ''} ayar altın, ${productDetails ? productDetails.gram : ''} gram, altın takı, kuyumcu, BiKuyum, ${productDetails ? productDetails.magaza_adi : ''}, ${productDetails ? productDetails.stok_kodu : ''}`}
          />

          {/* Open Graph Meta Etiketleri - Sosyal Medya Paylaşımları için */}
          <meta property="og:title" content={`BiKuyum | ${productDetails ? productDetails.baslik : 'Mağaza'}`} />
          <meta
            property="og:description"
            content={`${productDetails ? productDetails.baslik : ''} - ${productDetails ? productDetails.ayar : ''} ayar ${productDetails ? productDetails.gram : ''} gram altın ürünü. ${productDetails ? productDetails.fiyat.toLocaleString('tr-TR') : ''} TL fiyatıyla BiKuyum'da.`}
          />
          <meta property="og:type" content="product" />
          <meta property="og:url" content={window.location.href} />
          {productDetails && productDetails.image && Object.values(productDetails.image)[0] && (
            <meta property="og:image" content={getImageUrl(Object.values(productDetails.image)[0])} />
          )}
          <meta property="og:site_name" content="BiKuyum" />
          <meta property="og:locale" content="tr_TR" />

          {/* Twitter Card Meta Etiketleri */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`BiKuyum | ${productDetails ? productDetails.baslik : 'Mağaza'}`} />
          <meta
            name="twitter:description"
            content={`${productDetails ? productDetails.baslik : ''} - ${productDetails ? productDetails.ayar : ''} ayar ${productDetails ? productDetails.gram : ''} gram altın ürünü. ${productDetails ? productDetails.fiyat.toLocaleString('tr-TR') : ''} TL fiyatıyla BiKuyum'da.`}
          />
          {productDetails && productDetails.image && Object.values(productDetails.image)[0] && (
            <meta name="twitter:image" content={getImageUrl(Object.values(productDetails.image)[0])} />
          )}

          {/* Product Specific Meta Etiketleri */}
          {productDetails && (
            <>
              <meta name="product:price:amount" content={productDetails.fiyat} />
              <meta name="product:price:currency" content="TRY" />
              <meta name="product:availability" content={productDetails.stok > 0 ? "in stock" : "out of stock"} />
              <meta name="product:condition" content="new" />
              <meta name="product:brand" content={productDetails.magaza_adi} />
            </>
          )}

          {/* Canonical URL */}
          <link rel="canonical" href={window.location.href} />

          {/* JSON-LD Yapılandırılmış Veri */}
          {productDetails && (
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "Product",
                "name": productDetails.baslik,
                "image": productDetails.image && Object.values(productDetails.image).filter(img => img).map(img => getImageUrl(img)),
                "description": `${productDetails.ayar} ayar ${productDetails.gram} gram altın ürünü.`,
                "sku": productDetails.stok_kodu,
                "brand": {
                  "@type": "Brand",
                  "name": productDetails.magaza_adi
                },
                "offers": {
                  "@type": "Offer",
                  "url": window.location.href,
                  "priceCurrency": "TRY",
                  "price": productDetails.fiyat,
                  "priceValidUntil": new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                  "availability": productDetails.stok > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                  "seller": {
                    "@type": "Organization",
                    "name": productDetails.magaza_adi
                  }
                },
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.5",
                  "reviewCount": "1"
                },
                "weight": {
                  "@type": "QuantitativeValue",
                  "value": productDetails.gram,
                  "unitCode": "GRM"
                }
              })}
            </script>
          )}
        </Helmet>
      </div>
      <div className='product-detail'>
        {showAddToCartModal && (
          <AddToCartModal
            product={{
              name: productDetails.baslik,
              price: productDetails.fiyat,
              image: getImageUrl(Object.values(productDetails.image)[0])
            }}
            recommendedProducts={shuffleArray(products).slice(0, 4)}
            onClose={() => setShowAddToCartModal(false)}
            onGoToCart={handleGoToCart}
            onContinueShopping={() => setShowAddToCartModal(false)}
            isFavorite={isFavorite}
            onFavoriteToggle={handleRecommendedFavoriteToggle}
          />
        )}
        <div className="product-detail-container">
          <div className='imgs position-relative overflow-hidden'>
            <ImageGallery
              images={Object.values(productDetails.image).filter(image => image)}
              productDetails={productDetails}
            />
            {productDetails.eski_fiyat !== productDetails.fiyat && (
              <div className="discount-badge">
                {/* {Math.floor(((productDetails.eski_fiyat - productDetails.fiyat) / productDetails.eski_fiyat) * 100)}% */}
                <div className='d-flex flex-column'>
                  {(((productDetails.eski_fiyat - productDetails.fiyat) / productDetails.eski_fiyat) * 100).toFixed(1)}%
                  <span>İndirim</span>
                </div>
              </div>
            )}
            {/* Floating Action Buttons */}
            <div className="floating-actions">
              <div className="floating-favorite" onClick={handleFavoriteToggle}>
                <FontAwesomeIcon
                  icon={isFavorite(productDetails) ? SolidHeart : RegularHeart}
                  style={{
                    color: isFavorite(productDetails) ? '#ff4757' : '#2f3542',
                    fontSize: '20px'
                  }}
                />
              </div>
              <div className="floating-share" onClick={handleShare}>
                <FontAwesomeIcon
                  icon={faShare}
                  style={{
                    color: '#2f3542',
                    fontSize: '18px'
                  }}
                />
              </div>
            </div>
          </div>
          <div className="product-info">
            <h1>{productDetails.baslik}</h1>
            <div className='product-actions'>
              <div className='d-flex flex-sm-row gap-2'>
                <p className='fs-6 fs-7'>Satıcı Mağaza:</p>
                <a href={`/${productDetails.magaza_sef}/all`}>
                  <p className='fw-bold fs-6 fs-7'>{productDetails.magaza_adi}</p>
                </a>
              </div>
            </div>
            <div className="detail-prices">
              {productDetails.fiyat && productDetails.eski_fiyat !== productDetails.fiyat ? (
                <>
                  <h2 className="detail-originall-price" style={{ textDecoration: 'line-through' }}>
                    {productDetails.eski_fiyat.toLocaleString('tr-TR')} TL
                  </h2>
                  <h2 className="detail-discountedd-price">
                    {productDetails.fiyat.toLocaleString('tr-TR')} TL
                  </h2>
                </>
              ) : (
                <h2 className="detail-originall-price">
                  {productDetails.fiyat.toLocaleString('tr-TR')} TL
                </h2>
              )}
            </div>
            <div className="payment-options d-flex gap-2">
              <span className='taksit-secenegi'>3 Taksit Seçeneği</span>
              {/* <span className='taksit-secenegi'>EFT ile %2 indirim</span> */}
            </div>
            <p className='fw-bold'>Stok Kodu: {productDetails.stok_kodu}</p>
            {
              productDetails.kapora === 1 && (
                <p className='text-danger fs-6 alert alert-warning'>Bu ürünün kaporası verilmiştir</p>
              )
            }
            {/* Görüntülenme Metni */}
            <div className='d-flex align-items-center gap-2 fs-6 wiev-count'>
              <i className="fas fa-eye"></i>
              <span className='fs-6'>
                {(productDetails.view_count ?? 0).toLocaleString('tr-TR')} incelenme
              </span>
            </div>
            {isOutOfStock && <p className='stok-bilgi'>Ürün stokta bulunmamaktadır.</p>}
            <div className='explanation'>
              <p>
                Ürünümüz <strong>{productDetails.ayar}</strong> ayar onaylanmış ve kontrol edilmiş <strong>{productDetails.gram}</strong> Gram Altındır.
                Tüm sorularınız için, bizimle
                <a
                  href={`https://api.whatsapp.com/send?phone=905441000229&text=Merhaba, ${productDetails.sef} ürününü almak istiyorum.Link: ${encodeURIComponent(window.location.href)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button target="_blank"
                    rel="noopener noreferrer"
                    className='whatsapp-info'>Whatsapp</button>
                </a>
                "tan irtibata geçebilirsiniz.
              </p>
            </div>
            {productDetails.variants && productDetails.variants.length > 0 && (
              <div className="variants">
                <div className='variant-title'>
                  <h4 className='fw-bold'>Pırlanta Bilgileri</h4>
                </div>
                <ul>
                  {productDetails.variants.map((variant, index) => (
                    <div key={index} className="variants-item">
                      <div>
                        <strong className='fs-6 fs-7'>{variant.variant_title}:</strong>
                        <span className='fs-6 fs-7'> {variant.karat}</span>
                      </div>
                    </div>
                  ))}
                </ul>
              </div>
            )}
            {productDetails.kategori.includes("75") || productDetails.kategori.includes("103") || productDetails.kategori.includes("112") ? (
              <div className="ring-size">
                <p>Ölçü Seçin:</p>
                <select onChange={handleSizeChange} value={selectedSize} disabled={isRingLocked}>
                  {Array.from({ length: 25 }, (_, index) => index + 6).map(size => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                {!isRingLocked && getRingSizeDescription() && (
                  <p className="size-price-difference" style={{ marginTop: '8px', color: '#dc3545', fontWeight: 'bold' }}>
                    {getRingSizeDescription()}
                  </p>
                )}
                {isRingLocked && (
                  <p className="size-price-difference">Bu ürün için ölçü değiştirilemez.</p>
                )}
              </div>
            ) : null}
            <div className='d-md-block d-none'>
              <div className="purchase-options">
                <a href="#">
                  <button
                    onClick={handleAddToCart}
                    className='card-button'
                    disabled={isAddingToCart}
                    style={{ opacity: isAddingToCart ? 0.6 : 1, cursor: isAddingToCart ? 'not-allowed' : 'pointer' }}
                  >
                    {isAddingToCart ? 'Ekleniyor...' : 'Sepete Ekle'}
                  </button>
                </a>
                <a>
                  <button
                    onClick={async () => {
                      // Çoklu tıklama koruması
                      if (isAddingToCart) {
                        return;
                      }

                      if ((isSarrafiyeProduct && hasNonSarrafiyeInCart) || (!isSarrafiyeProduct && hasSarrafiyeInCart)) {
                        setIsBuyNowAction(true);
                        setShowSarrafiyeModal(true);
                        return;
                      }

                      setIsAddingToCart(true);
                      try {
                        if (productDetails.kategori.includes("75") || productDetails.kategori.includes("103") || productDetails.kategori.includes("112")) {
                          await addToCart({ urun_id: productDetails.id, size: selectedSize });
                        } else {
                          await addToCart({ urun_id: productDetails.id });
                        }
                        setTimeout(() => {
                          window.location.href = "/card";
                        }, 300);
                      } catch (error) {
                        console.error("Sepete eklenirken hata oluştu:", error);
                      } finally {
                        setIsAddingToCart(false);
                      }
                    }}
                    className='card-button-buy'
                    disabled={isAddingToCart}
                    style={{ opacity: isAddingToCart ? 0.6 : 1, cursor: isAddingToCart ? 'not-allowed' : 'pointer' }}
                  >
                    {isAddingToCart ? 'Ekleniyor...' : 'Hemen Satın Al'}
                  </button>
                </a>
                <a
                  href={`https://api.whatsapp.com/send?phone=905441000229&text=Merhaba, ${productDetails.sef} ürününü almak istiyorum.Link: ${encodeURIComponent(window.location.href)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button target="_blank"
                    rel="noopener noreferrer"
                    className='whatsapp'>Whatsapp ile Sipariş</button>
                </a>
                {(showPopup || showSarrafiyeModal) && (
                  <Popup
                    message={message}
                    onContinue={handleContinueShopping}
                    onGoToCart={handleGoToCart}
                    closePopup={closePopup}
                    duration={showSarrafiyeModal ? 0 : 3000}
                    isSarrafiyeModal={showSarrafiyeModal}
                    onConfirm={() => handleSarrafiyeConfirm(isBuyNowAction)}
                    onCancel={handleSarrafiyeCancel}
                  />
                )}
              </div>
              <div className="seller-info justify-content-around">
                <div className='seller-info-logo'>
                  <a href={`/${productDetails.magaza_sef}/all`}>
                    <img src={getImageUrl(productDetails.profil_fotografi)} alt="profil-fotografi" />
                  </a>
                </div>
                <div className='seller-info-store'>
                  <p className='text-center'>Satıcı Mağaza</p>
                  <a href={`/${productDetails.magaza_sef}/all`}>
                    <p>{productDetails.magaza_adi}</p>
                  </a>
                  <a href={`/${productDetails.magaza_sef}/all`}>
                    <button className="store">Mağazayı İncele</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='tabs-container'>
          <div className="tabs-header">
            <button
              className={activeTab === 'description' ? 'active' : ''}
              onClick={() => setActiveTab('description')}
            >
              Açıklama
            </button>
            <button
              className={activeTab === 'shipping' ? 'active' : ''}
              onClick={() => setActiveTab('shipping')}
            >
              Teslimat & İade
            </button>
          </div>
          <div className='tabs-content'>
            {activeTab === 'description' && (
              <div className='tab-pane'>
                <h4 className='fw-bold'>{productDetails.baslik}</h4>
                <div dangerouslySetInnerHTML={{ __html: productDetails.aciklama }} />
                <p className='fs-6 fs-7'>
                  Tüm sorularınız için, bizimle
                  <a
                    href={`https://api.whatsapp.com/send?phone=905441000229&text=Merhaba, ${productDetails.sef} ürününü almak istiyorum.Link: ${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button target="_blank"
                      rel="noopener noreferrer"
                      className='whatsapp-info'>Whatsapp</button>
                  </a>
                  'tan irtibata geçebilirsiniz.
                </p>
              </div>
            )}
            {activeTab === "shipping" && (
              <div className='tab-pane'>
                <h4>Teslimat & İade Koşulları</h4>
                {institutionals?.aciklama ? (
                  <div dangerouslySetInnerHTML={{ __html: institutionals.aciklama }} />
                ) : (
                  <p>Yükleniyor...</p>
                )}
              </div>
            )}
          </div>
        </div>
        <div className='recommendation-container'>
          <h3 className='my-4'>Tavsiye Ettiğimiz Ürünler</h3>
          <div className='recommendation'>
            {shuffleArray(products).slice(0, productLimit).map(product => (
              <ProductCard
                key={product.sef}
                product={product}
                isFavorite={isFavorite}
                onFavoriteToggle={handleRecommendedFavoriteToggle}
                showGramPrice={true}
              />
            ))}
          </div>
        </div>
        <div className='d-md-none d-block'>
          <div className="purchase-options">
            <a href="#">
              <button
                onClick={handleAddToCart}
                className='card-button'
                disabled={isAddingToCart}
                style={{ opacity: isAddingToCart ? 0.6 : 1, cursor: isAddingToCart ? 'not-allowed' : 'pointer' }}
              >
                {isAddingToCart ? 'Ekleniyor...' : 'Sepete Ekle'}
              </button>
            </a>
            <a>
              <button
                onClick={async () => {
                  // Çoklu tıklama koruması
                  if (isAddingToCart) {
                    return;
                  }

                  if ((isSarrafiyeProduct && hasNonSarrafiyeInCart) || (!isSarrafiyeProduct && hasSarrafiyeInCart)) {
                    setIsBuyNowAction(true);
                    setShowSarrafiyeModal(true);
                    return;
                  }

                  setIsAddingToCart(true);
                  try {
                    if (productDetails.kategori.includes("75") || productDetails.kategori.includes("103") || productDetails.kategori.includes("112")) {
                      await addToCart({ urun_id: productDetails.id, size: selectedSize });
                    } else {
                      await addToCart({ urun_id: productDetails.id });
                    }
                    setTimeout(() => {
                      window.location.href = "/card";
                    }, 300);
                  } catch (error) {
                    console.error("Sepete eklenirken hata oluştu:", error);
                  } finally {
                    setIsAddingToCart(false);
                  }
                }}
                className='card-button-buy'
                disabled={isAddingToCart}
                style={{ opacity: isAddingToCart ? 0.6 : 1, cursor: isAddingToCart ? 'not-allowed' : 'pointer' }}
              >
                {isAddingToCart ? 'Ekleniyor...' : 'Hemen Satın Al'}
              </button>
            </a>
            <a
              href={`https://api.whatsapp.com/send?phone=905441000229&text=Merhaba, ${productDetails.sef} ürününü almak istiyorum.Link: ${encodeURIComponent(window.location.href)}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button target="_blank"
                rel="noopener noreferrer"
                className='whatsapp'>Whatsapp ile Sipariş</button>
            </a>
            {(showPopup || showSarrafiyeModal) && (
              <Popup
                message={message}
                onContinue={handleContinueShopping}
                onGoToCart={handleGoToCart}
                closePopup={closePopup}
                duration={showSarrafiyeModal ? 0 : 3000}
                isSarrafiyeModal={showSarrafiyeModal}
                onConfirm={() => handleSarrafiyeConfirm(isBuyNowAction)}
                onCancel={handleSarrafiyeCancel}
              />
            )}
          </div>
          <div className="seller-info justify-content-around">
            <div className='seller-info-logo'>
              <a href={`/${productDetails.magaza_sef}/all`}>
                <img src={getImageUrl(productDetails.profil_fotografi)} alt="profil-fotografi" />
              </a>
            </div>
            <div className='seller-info-store'>
              <p className='text-center'>Satıcı Mağaza</p>
              <a href={`/${productDetails.magaza_sef}/all`}>
                <p>{productDetails.magaza_adi}</p>
              </a>
              <a href={`/${productDetails.magaza_sef}/all`}>
                <button className="store">Mağazayı İncele</button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <SoldAlert />
    </>
  );
};

export default ProductDetails;